module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/service-eca538a434f09057015905a7ba099bd2.webp";